import * as R from 'ramda'

const formatDeviceType = (data) => (
    data.RESULTS.reduce((obj, r) => {
        obj.device.push(r.LV)
        obj.pct.push(r.PCT)
        obj.count.push(r.RESULTS[0].CT)
        return obj
    }, {
        device: [],
        pct: [],
        count: [],
    })
)

const formatDeviceTypeV2 = (data) => (
    Object.keys(R.or(data, {})).reduce((obj, d) => {
        obj.device.push(d)
        obj.pct.push(data[d].percentage)
        obj.count.push(data[d].count)
        return obj
    }, {
        device: [],
        pct: [],
        count: [],
    })
)

const formatBrowserType = (data) => (
    data.RESULTS.reduce((obj, r) => {
        obj.browser.push(r.LV)
        obj.pct.push(r.PCT)
        obj.count.push(r.RESULTS[0].CT)
        return obj
    }, {
        browser: [],
        pct: [],
        count: [],
    })
)

const formatBrowserTypeV2 = (data) => (
    Object.keys(R.or(data, {})).reduce((obj, k) => {
        obj.browser.push(k)
        obj.pct.push(data[k].percentage)
        obj.count.push(data[k].count)
        return obj
    }, {
        browser: [],
        pct: [],
        count: [],
    })
)

const formatStatsV2 = (data, pages) => {
    const formatted = {
        details: {
            complete: [],
            drop: [],
            screen: [],
        },
        aggregate: {
            total: {
                complete: R.pathOr(0, ['aggregate', 'total', 'complete'], data),
                drop: R.pathOr(0, ['aggregate', 'total', 'drop'], data),
                screen: R.pathOr(0, ['aggregate', 'total', 'screen'], data),
            },
            emailComplete: R.pathOr(0, ['aggregate', 'emailComplete'], data),
        },
    }
    pages.forEach((p) => {
        formatted.details.complete.push(R.pathOr(0, ['details', 'complete', p.id.toUpperCase()], data))
        formatted.details.drop.push(R.pathOr(0, ['details', 'drop', p.id.toUpperCase()], data))
        formatted.details.screen.push(R.pathOr(0, ['details', 'screen', p.id.toUpperCase()], data))
    })

    return formatted
}

const formatStats = (data) => {
    const formatted = {
        details: {
            complete: [],
            drop: [],
            screen: [],
        },
        aggregate: {
            total: {
                complete: data.COMPLETEDTOTAL || 0,
                drop: data.DROPTOTAL || 0,
                screen: data.SCREENTOTAL || 0,
            },
            emailComplete: data.EMAILRESPONSERATE || 0,
        },
    }
    data.RESULTS.forEach((r) => {
        formatted.details.complete.push(r.COMPLETEDCOUNT)
        formatted.details.drop.push(r.DROPCOUNT)
        formatted.details.screen.push(r.SCREENCOUNT)
    })

    return formatted
}

const benhcmarkMap = {
    IN: 'industry',
    PO: 'portfolio',
    IN_TERM1: 'sector',
    CO: 'company',
}

const replaceKey = (k) => (['client'].includes(k.toLowerCase()) ? 'company' : k)

const numberRange = (data) => {
    const includedBenchmarks = {}
    const questionBencharkKeys = []
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        }
    })

    const hasComparisons = (data.Y1 && data.Y1.TOTALRV > 0)
    const formatted = data.RESULTS.reduce((obj, r) => {
        obj.yOptions.push({
            label: r.LV.replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ''),
            id: r.QOID,
            isHidden: false,
        })
        if (hasComparisons) {
            obj.comparison[data.Y1.SURVEYID.toLowerCase()].push(r.Y1.PCT)
        }
        obj.pctOfResponses.push(r.RESULTS[0].PCT)
        obj.numberOfResponses.push(r.RESULTS[0].CT)
        questionBencharkKeys.forEach((k) => {
            obj.benchmarks[benhcmarkMap[k]].push(r[k].PCT)
        })
        return obj
    }, {
        yOptions: [],
        numberOfResponses: [],
        pctOfResponses: [],
        comparison: hasComparisons ? {
            [data.Y1.SURVEYID.toLowerCase()]: [],
        } : {},
        aggregate: {
            average: 0,
            comparison: hasComparisons ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
            userAverage: 0,
            benchmarks: {},
            nps: {
                survey: 0,
                client: 0,
            },
        },
        benchmarks: includedBenchmarks,
    })
    formatted.aggregate.average = data.S.MEAN || 0
    // if (data.DSPYOURSCORE) {
    questionBencharkKeys.forEach((k) => {
        // if (Object.hasOwnProperty.call(data.CO, 'NPS')) {
        //     formatted.aggregate.nps.client = data.CO.NPS
        // }
        // if (data[k] && data[k].TOTALRV > 0) {
        formatted.aggregate.benchmarks[benhcmarkMap[k]] = [data[k].MEAN]
        // }
    })
    // }
    if (data.CO) {
        if (Object.hasOwnProperty.call(data.CO, 'NPS')) {
            formatted.aggregate.nps.client = data.CO.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.CO_TERM1) {
        if (Object.hasOwnProperty.call(data.CO_TERM1, 'NPS')) {
            formatted.aggregate.nps.sector = data.CO_TERM1.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.IN_TERM1) {
        if (Object.hasOwnProperty.call(data.IN_TERM1, 'NPS')) {
            formatted.aggregate.nps.sector = data.IN_TERM1.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.IN) {
        // formatted.aggregate.benchmarks.industry = [data.IN.MEAN]
        if (Object.hasOwnProperty.call(data.IN, 'NPS')) {
            formatted.aggregate.nps.industry = data.IN.NPS
        }
    }
    if (data.PO) {
        // formatted.aggregate.benchmarks.portfolio = [data.PO.MEAN]
        if (Object.hasOwnProperty.call(data.PO, 'NPS')) {
            formatted.aggregate.nps.portfolio = data.PO.NPS
        }
    }
    if (hasComparisons) {
        // console.log('aggregate Comparisons -> ', data.Y1)
        formatted.aggregate.nps[data.Y1.SURVEYID.toLowerCase()] = data.Y1.NPS || 0
        formatted.aggregate.comparison[data.Y1.SURVEYID.toLowerCase()].push(data.Y1.MEAN)
        // console.log(formatted.aggregate.comparison)
    }

    formatted.aggregate.nps.survey = data.S.NPS || 0
    formatted.aggregate.userAverage = data.S.USERSAVG || 0
    // console.log(formatted)
    return formatted
}

const singleAxis = (data, question) => {
    const includedBenchmarks = {}
    const questionBencharkKeys = []
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        } else {
            const optionHasBenchmark = data.RESULTS.some((d) => d[k] && d[k].CT > 0)
            if (optionHasBenchmark) {
                questionBencharkKeys.push(k)
                includedBenchmarks[benhcmarkMap[k]] = []
            }
        }
    })

    const hasComparisons = R.pathOr([], ['RESULTS'], data).some(({ Y1 }) => R.pathOr(0, ['CT'], Y1) > 0)
    const dataMap = data.RESULTS.reduce((map, r) => {
        map.set(r.QOID.toUpperCase(), r)
        return map
    }, new Map())
    const formatted = question.optionSet.options.reduce((obj, o) => {
        const r = dataMap.get(o.id.toUpperCase())
        obj.yOptions.push({
            label: r.LV.replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ''),
            id: r.QOID,
            isHidden: false,
        })
        if (hasComparisons) {
            obj.comparison[data.Y1.SURVEYID.toLowerCase()].push(r.Y1.PCT)
        }
        const pctPath = question.questionTypeCode === 'PC'
            ? ['S', 'PCT']
            : ['RESULTS', 0, 'PCT']

        const numPath = question.questionTypeCode === 'PC'
            ? ['S', 'CT']
            : ['RESULTS', 0, 'CT']

        obj.pctOfResponses.push(R.pathOr(0.00, pctPath)(r))
        obj.numberOfResponses.push(R.pathOr(0.00, numPath)(r))
        questionBencharkKeys.forEach((k) => {
            obj.benchmarks[benhcmarkMap[k]].push(r[k].PCT)
        })
        obj.hasResponses = (obj.hasResponses || R.pathOr(0.00, numPath)(r) > 0)
        return obj
    }, {
        yOptions: [],
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        comparison: hasComparisons ? {
            [data.Y1.SURVEYID.toLowerCase()]: [],
        } : {},
        aggregate: {
            average: 0,
            comparison: hasComparisons ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
            userAverage: 0,
            benchmarks: {},
            nps: {
                survey: 0,
                client: 0,
            },
        },
        benchmarks: includedBenchmarks,
    })
    formatted.aggregate.average = data.S.MEAN || 0
    // if (data.DSPYOURSCORE) {
    questionBencharkKeys.forEach((k) => {
        // if (Object.hasOwnProperty.call(data.CO, 'NPS')) {
        //     formatted.aggregate.nps.client = data.CO.NPS
        // }
        // if (data[k] && data[k].TOTALRV > 0) {
        formatted.aggregate.benchmarks[benhcmarkMap[k]] = [data[k].MEAN]
        // }
    })
    // }
    if (data.CO) {
        if (Object.hasOwnProperty.call(data.CO, 'NPS')) {
            formatted.aggregate.nps.client = data.CO.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.CO_TERM1) {
        if (Object.hasOwnProperty.call(data.CO_TERM1, 'NPS')) {
            formatted.aggregate.nps.sector = data.CO_TERM1.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.IN_TERM1) {
        if (Object.hasOwnProperty.call(data.IN_TERM1, 'NPS')) {
            formatted.aggregate.nps.sector = data.IN_TERM1.NPS
        }
        // formatted.aggregate.benchmarks.company = [data.CO.MEAN]
    }
    if (data.IN) {
        // formatted.aggregate.benchmarks.industry = [data.IN.MEAN]
        if (Object.hasOwnProperty.call(data.IN, 'NPS')) {
            formatted.aggregate.nps.industry = data.IN.NPS
        }
    }
    if (data.PO) {
        // formatted.aggregate.benchmarks.portfolio = [data.PO.MEAN]
        if (Object.hasOwnProperty.call(data.PO, 'NPS')) {
            formatted.aggregate.nps.portfolio = data.PO.NPS
        }
    }
    if (hasComparisons) {
        // console.log('aggregate Comparisons -> ', data.Y1)
        formatted.aggregate.nps[data.Y1.SURVEYID.toLowerCase()] = data.Y1.NPS || 0
        formatted.aggregate.comparison[data.Y1.SURVEYID.toLowerCase()].push(data.Y1.MEAN)
        // console.log(formatted.aggregate.comparison)
    }

    formatted.aggregate.nps.survey = data.S.NPS || 0
    formatted.aggregate.userAverage = data.S.USERSAVG || 0
    // console.log(formatted)
    return formatted
}

const numberFormV2 = (data, question, surveyId, benchmarkData) => {
    const replaceKey = (k) => (['client'].includes(k.toLowerCase()) ? 'company' : k)
    const formatted = question.optionSet.reduce((obj, o, i) => {
        const optionId = o.question.id

        obj.pctOfResponses.push(R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'values', optionId.toUpperCase()], data))
        Object.keys(R.pathOr({}, ['comparison'], data)).forEach((c) => {
            const arr = R.pathOr([], ['comparison', c], obj)
            arr.push(R.pathOr(0.0, ['comparison', c, 'pct', optionId.toUpperCase()], data))
            obj.comparison[c] = arr
        })
        obj.numberOfResponses.push(data.responses[i])
        Object.keys(R.or(benchmarkData, {})).forEach((k) => {
            obj.benchmarks[replaceKey(k)].push(R.pathOr(0.0, [k, 'pct', optionId.toLowerCase()], benchmarkData))
        })
        return obj
    }, {
        yOptions: [],
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        comparison: {},
        aggregate: {
            average: R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'average'], data),
            comparison: Object.keys(R.pathOr({}, ['comparison'], data)).reduce((m, c) => {
                m[c] = R.pathOr(0.0, ['comparison', c, 'average'], data)
                return m
            }, {}),
            userAverage: R.pathOr(0.0, ['avgResponses'], data),
            benchmarks: Object.keys(R.or(benchmarkData, {})).reduce((m, k) => {
                m[replaceKey(k)] = R.pathOr(0.0, [k, 'average'], benchmarkData)
                return m
            }, {}),
            nps: {
                survey: R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'nps'], data),
                client: 0,
            },
        },
        benchmarks: Object.keys(R.or(benchmarkData, {})).reduce((m, k) => {
            m[replaceKey(k)] = []
            return m
        }, {}),
    })

    formatted.hasResponses = formatted.numberOfResponses.reduce((a, b) => a + b) > 0
    Object.keys(R.pathOr({}, ['comparison'], data)).forEach((k) => {
        formatted.aggregate.nps[k] = R.pathOr(0.0, ['comparison', k, 'nps'], data)
    }, {})
    Object.keys(R.or(benchmarkData, {})).forEach((k) => {
        formatted.aggregate.nps[replaceKey(k)] = R.pathOr(0.0, [k, 'nps'], benchmarkData)
    })

    return formatted
}

const singleAxisV2 = (data, question, surveyId, benchmarkData, comparison) => {
    const benchmarkKeys = Object.keys(benchmarkData)
    const comparisonData = Object.assign({}, R.pathOr({}, ['comparison'], data), comparison)
    const comparisonKeys = Object.keys(comparison)
    const comparisonTotals = comparisonKeys.length > 0
        ? Object.fromEntries(Object.entries(comparison).map(([key, value]) => [key, value.total]))
        : {}
    const uniqueResponses = data.comparison[surveyId.toUpperCase()]?.responses || 0

    const formatted = question.optionSet.options.reduce((obj, o, i) => {
        obj.pctOfResponses.push(R.pathOr(0.0, [surveyId.toUpperCase(), 'pct', o.id.toUpperCase()], comparisonData))
        comparisonKeys.forEach((c) => {
            const arr = R.pathOr([], [c], obj.comparison)
            arr.push(R.pathOr(0.0, [c, 'pct', o.id.toUpperCase()], comparisonData))
            obj.comparison[c] = arr
        })
        obj.numberOfResponses.push(R.pathOr(0, ['responses', i], data))
        benchmarkKeys.forEach((k) => {
            obj.benchmarks[replaceKey(k)].push(R.pathOr(0.0, [k, 'pct', o.id.toUpperCase()], benchmarkData))
        })
        return obj
    }, {
        yOptions: [],
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        comparison: {},
        aggregate: {
            average: R.pathOr(0.0, [surveyId.toUpperCase(), 'average'], comparisonData),
            comparison: comparisonKeys.reduce((m, c) => {
                m[c] = R.pathOr(0.0, [c, 'average'], comparisonData)
                return m
            }, {}),
            avgResponses: comparisonKeys.reduce((m, c) => {
                m[c] = R.pathOr(0.00, [c, 'avgResponses'], comparisonData)
                return m
            }, {}),
            userAverage: R.pathOr(0.0, ['avgResponses'], data),
            benchmarks: Object.keys(R.or(benchmarkData, {})).reduce((m, k) => {
                m[replaceKey(k)] = R.pathOr(0.0, [k, 'average'], benchmarkData)
                return m
            }, {}),
            nps: {
                survey: R.pathOr(0.0, [surveyId.toUpperCase(), 'nps'], comparisonData),
                client: 0,
            },
        },
        benchmarks: benchmarkKeys.reduce((m, k) => {
            m[replaceKey(k)] = []
            return m
        }, {}),
    })

    formatted.hasResponses = formatted.numberOfResponses.reduce((a, b) => a + b, 0) > 0
    formatted.uniqueResponses = uniqueResponses
    formatted.comparisonTotals = comparisonTotals
    comparisonKeys.forEach((k) => {
        formatted.aggregate.nps[k] = R.pathOr(0.0, [k, 'nps'], comparisonData)
    }, {})
    benchmarkKeys.forEach((k) => {
        formatted.aggregate.nps[replaceKey(k)] = R.pathOr(0.0, [k, 'nps'], benchmarkData)
    })

    return formatted
}

const doubleAxisV2 = (data, question, surveyId, comparison) => {
    const hasComparisons = Object.keys(comparison).length > 0
    const questionBencharkKeys = []
    const includedBenchmarks = {}
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        }
    })
    const formatted = question.optionSetY.options.reduce((obj, o, i) => {
        obj.yOptions.push({
            label: R.pathOr('', ['yOptions', i, 'label', 'fr_FR'], data),
            id: o.id,
            isHidden: false,
        })
        obj.numberOfResponses.push(R.pathOr(0, ['responses', i], data))

        question.optionSetX.options.forEach((xo) => {
            // const rr = r.xMap.get(`${o.id.toUpperCase()}_${xo.id.toUpperCase()}`)
            // const [yId, xId] = rr.QOID.split('_').map((id) => id.toUpperCase())
            const xId = xo.id.toUpperCase()
            if (!Object.hasOwnProperty.call(obj.xOptions, xId)) {
                obj.xOptions[xId] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[xId].numberOfResponses.push(0)
            obj.xOptions[xId].pctOfResponses.push(R.pathOr(0.0, ['pct', o.id.toUpperCase(), xId.toUpperCase()], data))
        })
        obj.aggregate.average.push(R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'values', o.id.toUpperCase()], data))

        Object.keys(comparison).forEach((c) => {
            const arr = R.pathOr([], ['aggregate', 'comparison', c], obj)
            arr.push(R.pathOr(0.0, [c, 'average', o.id.toUpperCase()], comparison))
            obj.aggregate.comparison[c] = arr
        })
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        numberOfResponses: [],
        hasResponses: false,
        pctOfResponses: [],
        aggregate: {
            average: [],
            userAverage: 0,
            benchmarks: includedBenchmarks,
            comparison: hasComparisons ? Object.keys(comparison).reduce((map, id) => ({ ...map, [id]: [] }), {}) : {},
            // {
            //     [data.Y1.SURVEYID.toLowerCase()]: [],
            // } : {},
        },
        benchmarks: {},
    })

    formatted.hasResponses = R.pathOr([], ['numberOfResponses'], formatted).reduce((a, b) => a + b, 0) > 0
    return formatted
}

const doubleAxis = (data, question) => {
    const hasComparisons = data.Y1 && data.Y1.TOTALRV > 0
    const questionBencharkKeys = []
    const includedBenchmarks = {}
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        }
    })

    const dataMap = data.RESULTS.reduce((obj, r) => {
        const xMap = r.RESULTS.reduce((xObj, x) => {
            xObj.set(x.QOID.toUpperCase(), x)
            return xObj
        }, new Map())

        obj.set(r.QOID.toUpperCase(), Object.assign.call(
            {},
            r,
            {
                xMap,
            },
        ))
        return obj
    }, new Map())

    const formatted = question.optionSetY.options.reduce((obj, o) => {
        const r = dataMap.get(o.id.toUpperCase())
        obj.yOptions.push({
            label: r.LV.replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ''),
            id: r.QOID,
            isHidden: false,
        })

        question.optionSetX.options.forEach((xo) => {
            const rr = r.xMap.get(`${o.id.toUpperCase()}_${xo.id.toUpperCase()}`)
            const [yId, xId] = rr.QOID.split('_').map((id) => id.toUpperCase())
            if (!Object.hasOwnProperty.call(obj.xOptions, xId)) {
                obj.xOptions[xId] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[xId].numberOfResponses.push(rr.CT)
            obj.xOptions[xId].pctOfResponses.push(rr.PCT)
        })
        obj.aggregate.average.push(r.S.AV)
        obj.numberOfResponses.push(r.S.CUMCT)
        questionBencharkKeys.forEach((k) => {
            obj.aggregate.benchmarks[benhcmarkMap[k]].push(r[k].AV)
        })
        if (hasComparisons) {
            obj.aggregate.comparison[data.Y1.SURVEYID.toLowerCase()].push(r.Y1.AV)
        }
        obj.hasResponses = (obj.hasResponses || r.S.CUMCT > 0)
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        numberOfResponses: [],
        hasResponses: false,
        pctOfResponses: [],
        aggregate: {
            average: [],
            userAverage: 0,
            benchmarks: includedBenchmarks,
            comparison: hasComparisons ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
        },
        benchmarks: {},
    })
    // console.log('doubleAxis', JSON.stringify(formatted, null, 4))
    return formatted
}

const smartGridV2 = (data, question, surveyId, benchmarkData) => {
    const replaceKey = (k) => (['client'].includes(k.toLowerCase()) ? 'company' : k)
    const hasComparisons = data.Y1 && data.Y1.TOTALRV > 0
    const questionBencharkKeys = []
    const includedBenchmarks = {}
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        }
    })
    const formatted = question.optionSetY.options.reduce((obj, o, i) => {
        obj.yOptions.push({
            label: R.pathOr('', ['yOptions', i, 'label', 'fr_FR'], data),
            id: o.id,
            isHidden: false,
        })
        obj.numberOfResponses.push(R.pathOr(0, ['responses', i], data))

        let agreed = 0

        question.optionSetX.options.forEach((xo) => {
            // const rr = r.xMap.get(`${o.id.toUpperCase()}_${xo.id.toUpperCase()}`)
            // const [yId, xId] = rr.QOID.split('_').map((id) => id.toUpperCase())
            const xId = xo.id.toUpperCase()
            if (!Object.hasOwnProperty.call(obj.xOptions, xId)) {
                obj.xOptions[xId] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[xId].numberOfResponses.push(0)
            obj.xOptions[xId].pctOfResponses.push(R.pathOr(0.0, ['pct', o.id.toUpperCase(), xId], data))

            if (xo.reportingValue >= 4) {
                agreed += R.pathOr(0.0, ['pct', o.id.toUpperCase(), xId], data)
            }
        })
        obj.aggregate.average.push(R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'values', o.id.toUpperCase()], data))

        obj.agreed.push(agreed)

        Object.keys(R.pathOr({}, ['comparison'], data)).forEach((c) => {
            const arr = R.pathOr([], ['aggregate', 'comparison', c], obj)
            arr.push(R.pathOr(0.0, ['comparison', c, 'values', o.id.toUpperCase()], data))
            obj.aggregate.comparison[c] = arr
        })
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        numberOfResponses: [],
        hasResponses: false,
        pctOfResponses: [],
        agreed: [],
        aggregate: {
            average: [],
            sgAverage: R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'average'], data),
            userAverage: 0,
            benchmarks: Object.keys(R.or(benchmarkData, {})).reduce((m, k) => {
                m[replaceKey(k)] = R.pathOr(0.0, [k, 'average'], benchmarkData)
                return m
            }, {}),
            comparison: hasComparisons ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
        },
        benchmarks: {},
    })
    // console.log('doubleAxis', JSON.stringify(formatted, null, 4))
    formatted.hasResponses = R.pathOr([], ['numberOfResponses'], formatted).reduce((a, b) => a + b, 0) > 0
    return formatted
}

const smartGrid = (data, question) => {
    const includedBenchmarks = {}
    const questionBencharkKeys = []
    Object.keys(benhcmarkMap).forEach((k) => {
        if (data[k] && data[k].TOTALRV > 0) {
            questionBencharkKeys.push(k)
            includedBenchmarks[benhcmarkMap[k]] = []
        }
    })
    const formatted = data.RESULTS.reduce((obj, r) => {
        obj.yOptions.push({
            label: r.LV.replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ''),
            id: r.QOID,
            isHidden: false,
        })
        // obj.pctOfResponses.push(r.RESULTS[0].PCT)
        // obj.numberOfResponses.push(r.RESULTS[0].CT)
        r.RESULTS.forEach((rr) => {
            const id = rr.QOID.split('_')[1].toUpperCase()
            if (!Object.hasOwnProperty.call(obj.xOptions, id)) {
                obj.xOptions[id.toUpperCase()] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[id].numberOfResponses.push(rr.CT)
            if (r.S.CUMCT > 0) {
                obj.xOptions[id].pctOfResponses.push(((rr.CT / r.S.CUMCT) * 100))
            }
        })
        obj.aggregate.average.push(r.S.AV)
        obj.numberOfResponses.push(r.S.CUMCT)
        obj.hasResponses = (obj.hasResponses || r.S.CUMCT > 0)
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        aggregate: {
            average: [],
            userAverage: 0,
            benchmarks: includedBenchmarks,
            nps: {
                survey: 0,
            },
        },
        benchmarks: {},
    })
    try {
        const agreePercentageOptions = ['6F17BA5C-48A2-40B4-AE80-12C17143E567', '1F96A604-45D2-46E5-B213-A4CE82804F55', 'A2A4EC8A-50AC-42BB-8917-3335689419F9', '06FEF4E6-0C5D-418A-95B0-86332460B6A4']
        formatted.agreed = formatted.yOptions.reduce((agreed, y, yIndex) => {
            let result = 0
            agreePercentageOptions.forEach((agreedOption) => {
                if (R.hasPath(['xOptions', agreedOption])(formatted)) {
                    result += R.path(['xOptions', agreedOption, 'pctOfResponses'], formatted)[yIndex]
                }
            })
            agreed.push(result)
            return agreed
        }, [])
        formatted.aggregate.sgAverage = (
            formatted.aggregate.average
                .reduce((sum, a) => (sum + a), 0) / (formatted.aggregate.average.length || 1)
        )
        questionBencharkKeys.forEach((k) => {
            formatted.aggregate.benchmarks[benhcmarkMap[k]] = data[k].MEAN
            // }
        })
    } catch (e) {
        console.log(e)
    }
    return formatted
}

const odV2 = (data, question, surveyId, benchmarkData) => {
    const formatted = question.optionSet.options.reduce((obj, option, i) => {
        obj.yOptions.push({
            label: R.pathOr('', ['yOptions', i, 'label', 'fr_FR'], data),
            id: option.id,
            isHidden: false,
        })

        question.optionSet.options.forEach((rr, i) => {
            if (!Object.hasOwnProperty.call(obj.xOptions, (i + 1))) {
                obj.xOptions[(i + 1)] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[(i + 1)].numberOfResponses.push(R.pathOr(0.0, ['pct', option.id.toUpperCase(), i + 1], data))
            obj.xOptions[(i + 1)].pctOfResponses.push(R.pathOr(0.0, ['pct', option.id.toUpperCase(), i + 1], data))
        })

        obj.hasResponses = true // (obj.hasResponses || r.S.CUMCT > 0)
        obj.aggregate.average.push(R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'values', option.id.toUpperCase()], data))
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        aggregate: {
            average: [],
            userAverage: 0,
            comparison: false ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
            benchmarks: {},
            nps: {
                survey: 0,
            },
        },
        benchmarks: {},
    })
    console.log('od2', formatted)
    console.log(data)
    return formatted
}

const od = (data, question) => {
    const hasComparisons = data.Y1
    const formatted = data.RESULTS.reduce((obj, r) => {
        obj.yOptions.push({
            label: r.LV.replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ''),
            id: r.QOID,
            isHidden: false,
        })

        r.RESULTS.forEach((rr) => {
            if (!Object.hasOwnProperty.call(obj.xOptions, rr.LV)) {
                obj.xOptions[rr.LV] = {
                    numberOfResponses: [],
                    pctOfResponses: [],
                }
            }
            obj.xOptions[rr.LV].numberOfResponses.push(rr.CT)
            obj.xOptions[rr.LV].pctOfResponses.push(rr.PCT)
        })
        if (hasComparisons) {
            obj.aggregate.comparison[data.Y1.SURVEYID.toLowerCase()].push(r.Y1.AV)
        }
        obj.hasResponses = (obj.hasResponses || r.S.CUMCT > 0)
        obj.aggregate.average.push(r.S.AV)
        return obj
    }, {
        yOptions: [],
        xOptions: {},
        hasResponses: false,
        numberOfResponses: [],
        pctOfResponses: [],
        aggregate: {
            average: [],
            userAverage: 0,
            comparison: hasComparisons ? {
                [data.Y1.SURVEYID.toLowerCase()]: [],
            } : {},
            benchmarks: {},
            nps: {
                survey: 0,
            },
        },
        benchmarks: {},
    })
    return formatted
}

const text = (data) => {
    const formatted = {
        numberOfResponses: [0],
    }

    return formatted
}

const urlVariable = (data, question) => (
    data.RESULTS.reduce((obj, r) => {
        if (!Object.hasOwnProperty.call(obj, r.QOID)) {
            obj.responses[r.QOID] = []
            obj.numberOfResponses[r.QOID] = 0
        }

        obj.numberOfResponses[r.QOID] += r.COUNT
        obj.responses[r.QOID].push(r.LANGVALUE)
        return obj
    }, {
        responses: {},
        numberOfResponses: {},
    })
)

const formatNew = (data, questionMap) => {
    const formattedData = {
        questions: {},
    }

    R.pathOr([], ['questions'], data).forEach((questionData) => {
        const { questionTypeCode, questionId } = questionData
        const {
            formId, pageQuestionId, metadata, settings,
        } = questionMap.get(questionId.toUpperCase())
        const formatKey = formId
            ? `${formId}_${questionId.toUpperCase()}`
            : pageQuestionId
        if (['TX', 'TA', 'UV', 'TL', 'FM', 'DT'].includes(questionTypeCode)) {
            formattedData.questions[formatKey] = text(questionData)
        } else if (['NF'].includes(questionTypeCode)) {
            formattedData.questions[formatKey] = {
                yOptions: questionData.yOptions.map((o) => ({
                    id: o,
                    label: o,
                    hidden: false,
                })),
                comparison: questionData.comparison,
                aggregate: questionData.aggregate,
                numberOfResponses: questionData.numberOfResponses,
                pctOfResponses: questionData.pct,
                benchmarks: {},
            }
        } else if (['I'].includes(questionTypeCode)) {
            formattedData.questions[formatKey] = {
                yOptions: R.pathOr([], ['yOptions'], questionData).map((o) => ({
                    id: o,
                    label: o,
                    hidden: false,
                })),
                numberOfResponses: questionData.numberOfResponses,
                pctOfResponses: questionData.pct,
                comparison: questionData.comparison,
                isAreaQuestion: isAreaQuestion({ metadata, settings }),
                aggregate: {
                    average: questionData.pct.reduce((avg, pct, index) => (
                        avg + ((pct / 100) * R.pathOr(0, ['yOptions', index], questionData))
                    ), 0),
                    comparison: questionData.aggregate.comparison,
                    userAverage: 0,
                    benchmarks: questionData.aggregate.benchmarks,
                    nps: {
                        survey: 0,
                        client: 0,
                    },
                },
                benchmarks: {},
            }
        } else if (['SB'].includes(questionTypeCode)) {
            const totalResponses = questionData.numberOfResponses.reduce((sum, n) => (sum + n), 0)
            formattedData.questions[formatKey] = {
                yOptions: Object.keys(questionData.yOptions).map((k) => ({
                    id: k,
                    label: questionData.yOptions[k],
                    hidden: false,
                })),
                hasResponses: totalResponses > 0,
                numberOfResponses: questionData.numberOfResponses,
                pctOfResponses: questionData.numberOfResponses.map((n) => n / totalResponses * 100),
                comparison: questionData.comparison,
                aggregate: {
                    average: questionData.aggregate.average,
                    comparison: questionData.aggregate.comparison,
                    userAverage: 0,
                    benchmarks: questionData.aggregate.benchmarks,
                    nps: {
                        survey: 0,
                        client: 0,
                    },
                },
                benchmarks: {},
            }
        }
    })

    return formattedData
}

const isAreaQuestion = ({ metadata, settings }) => {
    const { initialLocale } = metadata
    const leftSwitch = R.pathOr('', ['frontend', 'switch', 0, initialLocale, 'text'], settings)

    return ['M2', 'Ft2'].includes(leftSwitch)
}

const getQuestionKey = (questionData, questionGroupData) => {
    const pageQuestionId = R.pathOr('', ['pageQuestionId'], questionGroupData).toUpperCase()
    const questionId = R.pathOr('', ['questionId'], questionGroupData).toUpperCase()
    return questionData.formId ? `${questionData.formId}_${questionId}` : pageQuestionId
}

const formatV2 = (data, stats, questions, pages, surveyId, benchmarks, comparison) => {
    const formattedData = {
        questions: {},
        deviceData: formatDeviceTypeV2(R.pathOr({}, ['device'], stats)),
        browserData: formatBrowserTypeV2(R.pathOr({}, ['browser'], stats)),
        stats: formatStatsV2(R.pathOr({}, ['stats'], stats), pages),
    }

    const groupedData = R.groupBy(R.prop('questionId'), R.pathOr([], ['questions'], data))

    questions.forEach((q, i) => {
        const d = R.pathOr(undefined, [q.questionId.toLowerCase(), 0], groupedData)
        const benchmarkData = R.pathOr({}, [R.pathOr('', ['questionId'], d).toUpperCase()], benchmarks)
        const comparisonData = R.pathOr({}, [q.questionId.toUpperCase()], comparison)

        if (!R.isNil(d)) {
            if (['RD', 'CH', 'SB', 'PC'].includes(q.questionTypeCode)) {
                const key = getQuestionKey(q, d)
                formattedData.questions[key] = singleAxisV2(d, q, surveyId, benchmarkData, comparisonData)
            } else if (['TB', 'RT'].includes(q.questionTypeCode)) {
                formattedData.questions[R.pathOr('', ['pageQuestionId'], d).toUpperCase()] = doubleAxisV2(d, q, surveyId, comparisonData)
            } else if (['TX', 'TA', 'UV', 'TL', 'FM', 'DT'].includes(q.questionTypeCode)) {
                const key = getQuestionKey(q, d)
                formattedData.questions[key] = {
                    numberOfResponses: [R.pathOr(0, ['responses'], d)],
                }
            } else if (q.questionTypeCode === 'SG') {
                formattedData.questions[d.pageQuestionId.toUpperCase()] = smartGridV2(d, q, surveyId, benchmarkData)
            } else if (q.questionTypeCode === 'OD') {
                formattedData.questions[d.pageQuestionId.toUpperCase()] = odV2(d, q, surveyId, benchmarkData)
            } else if (['NF'].includes(q.questionTypeCode)) {
                formattedData.questions[d.pageQuestionId.toUpperCase()] = numberFormV2(d, q, surveyId, benchmarkData)
            } else if (['I'].includes(q.questionTypeCode)) {
                const key = getQuestionKey(q, d)
                formattedData.questions[key] = {
                    yOptions: R.pathOr([], ['options'], d).map((o) => ({
                        id: o,
                        label: o,
                        hidden: true,
                    })),
                    numberOfResponses: d.responses,
                    pctOfResponses: R.pathOr([], ['options'], d).map((o) => R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'pct', o], d)),
                    comparison: Object.keys(R.pathOr({}, ['comparison'], d)).map((c) => d.options.map((o) => R.pathOr(0.0, ['comparison', c, 'pct', o], d))),
                    aggregate: {
                        average: R.pathOr(0.0, ['comparison', surveyId.toUpperCase(), 'average'], d),
                        comparison: Object.keys(R.pathOr({}, ['comparison'], d)).map((c) => R.pathOr(0.0, ['comparison', c, 'average'], d)),
                        userAverage: 0,
                        benchmarks: {},
                        nps: {
                            survey: 0,
                            client: 0,
                        },
                    },
                    benchmarks: {},
                }
            }
        }
    })

    return formattedData
}

const format = (data, pageQuestionMap) => {
    const formattedData = {
        questions: {},
    }

    Object.keys(data).forEach((key) => {
        if (key === 'devicetype') {
            formattedData.deviceData = formatDeviceType(data[key])
        } else if (key === 'browsertype') {
            formattedData.browserData = formatBrowserType(data[key])
        } else if (key === 'surveyDropOff') {
            formattedData.stats = formatStats(data[key])
        } else { // question data
            const questionType = data[key].QUESTIONTYPE
            // const question = questions.get(key)
            const question = pageQuestionMap.get(key.toUpperCase())
            // 'I',
            if (['RD', 'CH', 'SB', 'PC'].includes(questionType)) {
                // console.log('singleaxis', key)
                formattedData.questions[key.toUpperCase()] = singleAxis(data[key], question)
            } else if (['I'].includes(questionType)) {
                // console.log('singleaxis', key)
                formattedData.questions[key.toUpperCase()] = numberRange(data[key], question)
            } else if (questionType === 'OD') {
                // console.log('od')
                formattedData.questions[key.toUpperCase()] = od(data[key], question)
            } else if (['TB', 'RT'].includes(questionType)) {
                formattedData.questions[key.toUpperCase()] = doubleAxis(data[key], question)
            } else if (['TX', 'TA', 'UV', 'TL', 'FM', 'DT'].includes(questionType)) {
                formattedData.questions[key.toUpperCase()] = text(data[key])
            } else if (questionType === 'SG') {
                formattedData.questions[key.toUpperCase()] = smartGrid(data[key], question)
            }
            // else if (questionType === 'UV') {
            //     formattedData.questions[key] = urlVariable(data[key], question)
            // }
        }
    })

    return formattedData
}

export {
    format,
    formatNew,
    formatV2,
}
